import type { ReactNode } from "react";
import {
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from "@volca/ui/components/ui/command";

export const CommandNestedState = ({
  heading,
  loading,
  error,
  onRetry,
  empty,
  count,
  children,
}: {
  heading?: string;
  loading: boolean;
  error: string | null;
  onRetry?: () => void;
  empty: string;
  count: number;
  children?: ReactNode;
}) => {
  if (loading) {
    return (
      <CommandGroup heading={heading}>
        <CommandItem disabled forceMount value={`${heading ?? "list"} loading`}>
          <span>Loading</span>
        </CommandItem>
      </CommandGroup>
    );
  }

  if (error) {
    return (
      <CommandGroup heading={heading}>
        <CommandItem
          forceMount
          value={`${heading ?? "list"} try again`}
          onSelect={onRetry}
        >
          <span>{error}</span>
        </CommandItem>
      </CommandGroup>
    );
  }

  if (count === 0) return <CommandEmpty>{empty}</CommandEmpty>;

  return (
    <>
      <CommandEmpty>No results.</CommandEmpty>
      <CommandGroup heading={heading}>{children}</CommandGroup>
    </>
  );
};

export const CommandLoadMore = ({
  loading,
  onLoad,
}: {
  loading: boolean;
  onLoad: () => void;
}) => (
  <CommandItem
    forceMount
    value="load more"
    onSelect={() => {
      if (!loading) onLoad();
    }}
  >
    <span>{loading ? "Loading" : "Load more"}</span>
  </CommandItem>
);
